module.exports = __webpack_public_path__ + "static/media/cu.6e5811bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cu.png
// module id = 1825
// module chunks = 0